import axios from 'axios';
import { quickAccessContentMock } from 'test/mock/quickAccessContentMock';

import { TGetLiferayQuickAccessContentResponse } from './types';
import { formatQuickAccessContentResponse } from './mapper';

export const getQuickAccessContent = async (liferayDomain: string, siteId: string) => {
  const vbzDebug = localStorage.getItem('vbzDebug');

  const url = `${liferayDomain}/o/headless-delivery/v1.0/sites/${siteId}/structured-contents?flatten=true&filter=friendlyUrlPath eq 'my_account_quick_access'`;

  if (vbzDebug) {
    return formatQuickAccessContentResponse(quickAccessContentMock);
  }

  return axios.get<TGetLiferayQuickAccessContentResponse>(url).then((res) => {
    return formatQuickAccessContentResponse(res.data);
  });
};
